import { IGetAllColetaPrecoUseCase } from "../../../presentation/useCases/read/get_all_coleta_preco_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ColetaPrecoLista } from "../../models/coleta_preco_lista";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllColetaPrecoUseCase
 */

export class GetAllColetaPrecoUseCase
  extends BasePaginatedUseCase<ColetaPrecoLista>
  implements IGetAllColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) {
    super();
  }

  async getAllColetaPreco(
    dataRequisicaoStart: Date | null,
    dataRequisicaoEnd: Date | null,
    fornecedor: number[] | null,
    requisicao: number[] | null,
    produtoServico: number[] | null,
    centroCusto: number[] | null,
    nroColeta: string | null,
    ordemCompra: number[] | null,
    status: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllColetaPreco(
      dataRequisicaoStart,
      dataRequisicaoEnd,
      fornecedor,
      requisicao,
      produtoServico,
      centroCusto,
      nroColeta,
      ordemCompra,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
